

type ListExtensionType = {
  [key: string]: string[];
};
export const isMatchType = (fileName: string, type: string): boolean => {
  if (!fileName) {
    return false;
  }
  const nameStrArr = fileName.split(".");
  const listExtension: ListExtensionType = {
    pdf: ["pdf"],
    doc: ["docx", "doc"],
    txt: ["txt"],
    ppt: ["ppt", "pptx"],
    xls: ["xls", "xlsx", "csv"],
    img: ["png", "jpg", "jpeg"],
    mp4: ["mp4"],
  };

  if (
    listExtension[type] &&
    listExtension[type].includes(nameStrArr[nameStrArr.length - 1])
  ) {
    return true;
  }

  return false;
};

export const convertFileToBase64 = (file: any):any => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

// export const imageCompressor = async (
//   file: File,
//   quality: "small" | "medium" | "large"
// ) => {
//   const sizeMB = {
//     small: 0.5,
//     medium: 1,
//     large: 1.5,
//   };
//   const resolution = {
//     small: 480,
//     medium: 720,
//     large: 1024,
//   };
//   const options = {
//     maxSizeMB: sizeMB[quality],
//     maxWidthOrHeight: resolution[quality],
//     useWebWorker: true,
//   };

//   return imageCompression(file, options);
// };
